export const FETCH_LEGENDASSOCIATIONS_REQUEST = 'FETCH_LEGENDASSOCIATIONS_REQUEST';
export const FETCH_LEGENDASSOCIATIONS_SUCCESS = 'FETCH_LEGENDASSOCIATIONS_SUCCESS';
export const FETCH_LEGENDASSOCIATIONS_FAILURE = 'FETCH_LEGENDASSOCIATIONS_FAILURE';